import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { event } from 'vue-gtag'


type DayjsInput = string | number | Date | dayjs.Dayjs | null | undefined;

const allowedSpecialPattern = /[\/'~#@$!%*?&^"]/;

/**
 * 날짜형식
 * @param dateParam 
 * @param formatParam 
 * @returns 
 */
export const toFormatDate = (dateParam: DayjsInput, formatParam: string) => {
  dayjs.locale('ko');
  return dayjs(dateParam).format(formatParam);
}


/**
 * 변환
 * @param data 
 * @returns 
 */

export const toFormatNumberUnit = (data: number | string | undefined | null): string => {
  // data가 undefined 또는 null인 경우 0으로 처리
  if (data === undefined || data === null) {
    return '0';
  }
  // data를 숫자로 변환
  const num = Number(data);
  // 숫자가 아닌 경우 0으로 처리
  if (isNaN(num)) {
    return '0';
  }
  // 숫자를 문자열로 변환
  const parts = num.toString().split(".");
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
}


/**
 * 문자 이모지 제거
 * @param text 
 * @returns 
 */
export const removeEmojiFromText = (text: string): string => {
  const emojiPattern = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  return text.replace(emojiPattern, '');
};

/**
 * 핸드폰 번호 형식 변환
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  // 숫자만 남기기  
  if (phoneNumber && phoneNumber.includes('-')) {
    return phoneNumber
  } else if( phoneNumber && !phoneNumber.includes('-')){
    return `${phoneNumber.substring(0,3)}-${phoneNumber.substring(3,7)}-${phoneNumber.substring(7)}`
  } else {
    return ''
  } 
}


/**
 * POC 반환
 * - P:PC웹, M:모바일웹, A:앱
 */
export const getPoc = (useCommonCode = false): string => {
  if (isMobileApp()) {
    return useCommonCode ? "App" : "A";
  } else if (isMobileWeb()) {
    return useCommonCode ? "Mobile" : "M";
  } else {
    return useCommonCode ? "PC" : "P";
  }
};

/**
 * API url 구하기
 * @param type : string
 * @returns string
 *   api url
 */
export const getStoreApiUrl = (
    type: string, 
    subUrl: string = '', 
    loginVersion: string = '',
    apiVersion : string = '/v1/' 
  ): string => {
  const config = useRuntimeConfig();

  const con = import.meta.server ? config : config.public;

  let url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
  let path = '';
  const version = '/v1/';
  const poc = getPoc();

  const platform = poc === 'A' ?
    'app' : poc === 'M' ?
      'mw' : poc === 'P' ?
        'pc' : '';

  if (type === 'feed') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `main/l2${version}${platform}`;
  } else if (type === 'event') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `${type}/l2${subUrl}${version}${platform}`;
  } else if (type === 'log') {
    path = `${type}${version}send`;
  } else if (type === 'cart') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `${type}/l2${version}count`;
  } else if (type === 'cartOrder') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `cart/l1${version}${platform}${subUrl}`;
  } else if (type === 'myInfo') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `main/l2${version}${type}`;
  } else if (type.indexOf('detail') > -1 || type.indexOf('shareSns') > -1) {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `goods/l2${version}${platform}${type}`;
  } else if (type === 'order') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `${type}${loginVersion}${apiVersion}${platform}`;
  } else if (type === 'catalog') {
    url = `${con.VITE_STORE_PRODUCT_API_URL}/`;
    path = `goods${version}${platform}/${type}`;
  } else if (type === 'coupon') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}/`;
    path = `${type}${loginVersion}${version}${platform}`;
  } else if (type === 'delivery') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/deliveryAddress';
  } else if (type === 'deliveryorder' || type === 'mydelivery') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/mydelivery';
  } else if (type === 'mypage') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/mypage';
  } else if (type === 'myttobak') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/mypage-subscriptions';
  } else if (type === 'mypageorder') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/myorder';
  } else if (type === 'gma') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/gma';
  } else if (type === 'mycoupon') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/mycoupon';
  } else if (type === 'myqna') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = '/myqna';
  } else if (type === 'payment') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/${type}${version}${platform}`;
  } else if (type === 'payment-v2') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = `/payment${loginVersion}${apiVersion}${platform}`;
  } else if (type === 'settle') {
    url = `${con.VITE_STORE_PRODUCT_API_URL}`;
    path = `/order${version}${platform}/settle`;
  } else if (type === 'settlettobak') {
    url = `${con.VITE_STORE_PRODUCT_API_URL}`;
    path = `/order${version}${platform}/status/settle`;
  } else if (type === 'ows') {
    url = `${con.VITE_DEVICE_SERVICE_API_URL}`;
    path = `/${type}`;
  } else if (type === 'ttobaks') {
    url = `${con.VITE_STORE_MYPAGE_API_URL}`;
    path = `/${type}`;
  } else if (type === 'search') {
    url = `${con.VITE_STORE_PRODUCT_API_URL}`;
    path = `/goods${version}${platform}/${type}`;
  } else if (type === 'searchgoods') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/goods/l2/${platform}/search` + subUrl;
  } else if (type === 'myPageCoupon') {
    url = `${con.VITE_STORE_MYPAGE_API_URL}`;
    path = `/${type}`;
  } else if (type === 'pharm') {
    url = `${con.VITE_STORE_ETC_V2_API_URL}`;
    path = `/${type}`;
  } else if (type === 'auth') {
    url = `${con.VITE_STORE_AUTH_API_URL}`;
  } else if (type === 'link') {
    url = `${con.VITE_LINK_API_URL}`;
  } else if (type == 'etc') {
    url = `${con.VITE_STORE_ETC_API_URL}`;
  } else if (type === 'etc_v2') {
    url = `${con.VITE_STORE_ETC_V2_API_URL}`;
  } else if (type == 'main') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/main/l2${version}${platform}`;
  } else if (type == 'keyword') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/main/l1`;
  } else if (type === 'goods') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/goods/l2${version}${platform}` + subUrl;
  } else if (type === 'notice') {
    url = `${con.VITE_STORE_ETC_V2_API_URL}`;
    path = '/notice';
  } else if (type === 'magazine') {
    url = `${con.VITE_STORE_ETC_V2_API_URL}`;
    path = '/ttobakMagazine';
  } else if (type === 'media') {
    url = `${con.VITE_ALARM_SUPPLEMENT_API_URL}`;
    path = '/videos';
  } else if (type === 'review') {
    url = `${con.VITE_STORE_MYPAGE_V2_API_URL}`;
    path = `/goodsdetail`;
  } else if (type === 'terms') {
    url = `${con.VITE_STORE_ETC_V2_API_URL}`;
    path = `/terms`;
  } else if (type === 'giftOrder') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/${type}/l3${version}${platform}`;
  } else if (type === 'category') {
    url = `${con.VITE_STORE_PRODUCT_API_URL_V2}`;
    path = `/goods`;
  } else {
    path = type;
  }

  return `${url}${path}`;
};

export const isAndroid = (): boolean => {
  const userAgent = navigator ? navigator.userAgent : useRequestHeaders()['user-agent'] as string;

  if (userAgent.match(/Android/i)) {
    return true;
  } else {
    return false;
  }
};

export const isIOS = (): boolean => {
  const userAgent = navigator ? navigator.userAgent : useRequestHeaders()['user-agent'] as string;

  if (userAgent.match(/iPhone|iPad/i)) {
    return true;
  } else {
    return false;
  }
};

export const getApplicationTypeWhereLoadedPage = (): string => {
  const userAgent = navigator ? navigator.userAgent : useRequestHeaders()['user-agent'] as string;

  if (isIOS()) {
    if (userAgent.match(/vsl/i)) {
      return "mobile-app";
    } else {
      return "mobile-web";
    }
  } else if (isAndroid()) {
    if (userAgent.match(/vsl/i)) {
      return "mobile-app";
    } else {
      return "mobile-web";
    }
  } else if (userAgent.match(/HeadlessChrome/i)) {
    return "mobile-web";
  } else {
    return "pc-web";
  }
};

export const isMobileWeb = (): boolean => {
  if (getApplicationTypeWhereLoadedPage() == "mobile-web") {
    return true;
  } else {
    return false;
  }
};

export const isMobileApp = (): boolean => {
  if (getApplicationTypeWhereLoadedPage() == "mobile-app") {
    return true;
  } else {
    return false;
  }
};

export const isPcWeb = (): boolean => {
  if (isMobileWeb() === false && isMobileApp() === false) {
    return true;
  } else {
    return false;
  }
};

export const goStoreTtobakCare = () => {
  let pram = '';

  // URL에서 파라미터 추출
  if (window.location.href.indexOf('?') !== -1) {
    pram = window.location.pathname + '?' + window.location.href.split('?')[1];
  } else {
    pram = window.location.pathname;
  }

  // iOS 여부에 따라 이동 방식 결정
  if (isIOS()) {
    window.location.replace(goStoreMain() + pram);
  } else {
    window.location.href = goStoreMain() + pram;
  }
};

export const goStoreMain = () => {

  const config = useRuntimeConfig();
  let resultURL = config.public.VITE_TTOBAK_WEB_URL; // 기본값 설정

  // 🌐 SSR 환경 (서버에서 실행)
  if (import.meta.env.SSR) {
    const headers = useRequestHeaders();
    const host = headers?.host || '';

    if (host.includes("desimone.co.kr")) {
      resultURL = config.public.VITE_DESIMONE_WEB_URL;
    } else if (host.includes("ttobakcare.com")) {
      resultURL = config.public.VITE_TTOBAK_WEB_URL;
    } 
  } else {
    // 🖥 CSR 환경 (브라우저에서 실행)
    const currentURL = window.location.hostname;

    if (currentURL.includes("desimone.co.kr")) {
      resultURL = config.public.VITE_DESIMONE_WEB_URL;
    } else if (currentURL.includes("ttobakcare.com")) {
      resultURL = config.public.VITE_TTOBAK_WEB_URL;
    }
  }

  console.log("pc url:::::::::::::::::", resultURL);
  return resultURL;


  //return import.meta.env.VITE_TTOBAK_WEB_URL
};

export const getBio11Url = (): string => {
  const config = useRuntimeConfig();

  if (isMobileApp()) {
    return config.public.VITE_BIO11_APP_URL;
  } else if (isMobileWeb()) {
    return config.public.VITE_BIO11_MOBILE_URL;
  } else {
    return config.public.VITE_BIO11_WEB_URL;
  }
};

/**
 * 바이오11 이미지 URL 반환
 * - 모바일(앱구분X), PC웹
 */
export const getBio11ImgUrl = (): string => {
  if (isMobileApp()) {
    return import.meta.env.VITE_TTOBAK_MOBILE_URL
  } else if (isMobileWeb()) {
    return import.meta.env.VITE_TTOBAK_MOBILE_URL
  } else {
    return import.meta.env.VITE_TTOBAK_WEB_URL
  }
}

/**
 * 이벤트 이미지 URL 반환
 */
export const getEventImgUrl = (type?: string): string => {
  const config = useRuntimeConfig();

  if (type === 'pc') {
    return config.public.VITE_EVENT_IMAGE_URL_PC;
  } else {
    return config.public.VITE_EVENT_IMAGE_URL;
  }
}

/**
* 이미지에러 임시 처리
*/
export const noImage = (e: Event, goods?: boolean) => {
  let imgPath: string;
  if (goods === true) {
    imgPath = getEventImgUrl() + '/img_noimage_goods.png';
  } else {
    imgPath = getEventImgUrl() + '/img_noimage.png';
  }

  const target = e.target as HTMLImageElement;
  if (target && target.tagName === 'IMG') {
    target.src = imgPath
  }
};
export const emptyImage = (): void => {
  const img = document.querySelectorAll('img');
  if (img) {
    for (let i = 0; i < img.length; i++) {
      if (img[i].src == '') {
        img[i].src = getEventImgUrl() + '/img_noimage.png';
      }
    }
  }
}

/**
 * 외부 스크립트 로딩
 * @param src url
 * @param type 1: HEAD에 추가, 2: BODY에 추가
 * @returns Promise<boolean>
 */
export const loadExternalScript = (src: string, type: number = 1, async: boolean = true): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    if (type === 1) {
      document.head.appendChild(script);
    } else {
      document.body.appendChild(script);
    }
  });
};

export const comma = (val: number): string => {
  let returnVal = '0';
  if (!isNaN(Math.round(val))) {
    returnVal = String(Math.round(val)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return returnVal;
};

export const getStoreDivideList = (list: Array<Record<string, any>>, len: number): Array<Record<string, any>> => {
  const listLen = list.length;
  const divide = Math.floor(listLen / len) + (Math.floor(listLen % len) > 0 ? 1 : 0);
  const newList = [];

  for (let i = 0; i < divide; i++) {
    // 0부터 n개씩 배열에 넣기
    newList.push(list.splice(0, len));
  }

  return newList;
};

// proxy 객체를 일반 객체로 변환
export const convertProxyToObject = (proxy: unknown): any => {
  if (typeof proxy === 'object' && proxy !== null) {
    if (Array.isArray(proxy)) {
      return proxy.map(item => convertProxyToObject(item));
    } else {
      const newObj: { [key: string]: any } = {};
      for (const key in proxy) {
        if (Object.prototype.hasOwnProperty.call(proxy, key)) {
          newObj[key] = convertProxyToObject((proxy as { [key: string]: unknown })[key]);
        }
      }
      return newObj;
    }
  }
  return proxy;
};

export const ttobakAppVersionCheck = (): string => {
  if (import.meta.server) return '';

  // const { $getCookie } = useNuxtApp();

  // let version = '';
  // const appSessId = $getCookie('APPSESSID');
  // if (appSessId) {
  //   const appsessidSplit = appSessId.split('.')
  //   if (appsessidSplit.length !== 3) {
  //     version = 'vsl3'
  //   } else {
  //     version = 'vsl4'
  //   }
  // }

  let version = '';

  // User-Agent 검사
  if (navigator.userAgent.includes('vsl4')) {
    version = 'vsl4';
  } else if (navigator.userAgent.includes('vsl3')) {
    version = 'vsl3';
  } 

  console.log('app version ::::: ', version)
  return version;
};

//앱에서 웹화면일때 앱으로 돌아가기
export const goBackTobakApp = () => {
  if (isAndroid()) {
    try {
      window.android.back();
    } catch (error) {
      navigateTo('/', { replace: true })
    }
  } else if(isIOS()){
    try {
      const message = {
        action: "back",
      };
      window.webkit?.messageHandlers?.experCounselHandler?.postMessage(message);
    } catch (error) {
      navigateTo('/', { replace: true })
    }
  }
}

// 배열을 문자열로 변환
export const convertArrayToString = (data: Array<string | number> | string | number): string => {
  if (Array.isArray(data)) {
    return data.filter(item => item !== undefined && item !== null && item !== '').join(',');
  }
  return data?.toString();
}

/**
 * 줄바꿈 <br>변환
 */
export const replaceNewLine = (text: string): string => {
  if (text != null && text != "") {
    return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }
  return ""
}

/**
 * <br>태그 제거
*/
export const noBrTag = (text: string): string => {
  if(text != null && text != ""){
    return text.replace(/<br\s*\/?>/gi, '')
  }
  return ""
}

export const getCustomerServiceUrl = (): string => {
  return "/mypage/qna";
}

export const getCompanyIntroduceUrl = (): string => {
  return import.meta.env.VITE_COMPANY_INTRODUCE_URL;
}

export const getPersonalInfoUrl = (): string => {
  // return this.getBio11Url() + "/page/index?tpl=service%2Fguide_privacy.html"
  return "/privacy";
}

export const getTermsUrl = (): string => {
  // return this.getBio11Url() + "/page/index?tpl=service%2Fguide_agreement.html"
  return "/agreement";
}

export const maskTextWithStart = (text: string, start: number | undefined, length: number): string => {
  // 시작 위치가 주어지지 않은 경우, 뒤에서부터 마스킹
  if (start === undefined) {
    if (text.length >= length) {
      return text.slice(0, -length) + "*".repeat(length);
    } else {
      return text;
    }
    // 시작 위치가 주어진 경우, 해당 위치부터 마스킹
  } else if (text.length >= start + length) {
    const maskedPart = "*".repeat(length);
    return text.slice(0, start) + maskedPart + text.slice(start + length);
  } else {
    return text;
  }
};

// hash param 가져오기
export const getHashParam = (param: string): string => {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);

  let value = '';
  if (params.has(param)) {
    const paramData = params.get(param);
    if (paramData) {
      value = paramData.replace(/\s/g, '+');
    }
  }
  
  return value;
};

/**
 * 생년월일로 부터 나이 계산
 * @param birthday 생년월일(YYYYMMDD)
 * @returns 
 */
export const calcAge = (birthday: string): number | null => {
  const pattern = /^[0-9]+$/;

  if (birthday.length != 8 || !pattern.test(birthday)) return null;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();
  const birthYear = parseInt(birthday.substring(0, 4));
  const birthMonth = parseInt(birthday.substring(4, 6));
  const birthDay = parseInt(birthday.substring(6, 8));

  let age = currentYear - birthYear;
  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
    age -= 1;
  }

  return age;
};

/**
 * 문자열에 포함된 특수문자가 허용된 특수문자인지 체크
 * @param str 
 * @returns 
 */
export const containsOnlyAllowedSpecialChars = (str: string): boolean => {
  const specialChars = str.match(/[^\w\s]/g);

  if (!specialChars) return true;

  return specialChars.every(char => allowedSpecialPattern.test(char));
};

export const buildQueryString = (params: Record<string, any>, url: string = ''): string => {
  if (Object.keys(params).length === 0) return '';

  const query = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
  return `${url}?${query}`;
};

// 숫자 정규식 체크
export const regExpNumber = (value: string) => {
  const regex = /[^0-9]/g;
  return value.replace(regex, '');
};


export const getAbsPath = (url: string): string => {
  const urlObj = new URL(url);
  return `${urlObj.pathname}${urlObj.search}${urlObj.hash}`;
};

// byte로 파일 사이즈 측정
export const bytesToSize = (bytes: number): string => {
  // binary unit byte(2^10) 사용시 true 10^3 사용시 false
  const useBinaryByte = true;
  // 소숫점 자리 적용 시 값 변경
  const decimals = 0;
  const byte = useBinaryByte ? 1024 : 1000;
  const sizes = useBinaryByte ? ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB'] : ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) {
    return 'n/a';
  }
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(byte)), sizes.length - 1);
  if (i === 0) {
    return `${bytes} ${sizes[i]}`;
  }
  return `${(bytes / (byte ** i)).toFixed(decimals)} ${sizes[i]}`;
}


/**
 * analytice Event
 *
 * @param {string} action     // 이벤트 카테고리(버튼클릭 등)
 * @param {Record<string,any>} value      // 숫자, 변수값
 */
export const analyticeEventSimple = (action: string, value: Record<string, any>): void => {
  const debugAction = ['view_item', 'view_cart', 'purchase', 'begin_checkout', 'add_to_cart']
  console.log('애널릭틱스 이벤트 호출', action)
  if (import.meta.env.VITE_ENV_TYPE === 'test' && debugAction.includes(action)) {
    value.debug_mode = true
  }
  if (isMobileApp()) {
    if (isAndroid()) {
      //안드로이드 호출시 
      if (window.AnalyticsWebInterface) {
        window.AnalyticsWebInterface.logEvent(action, JSON.stringify(value));
        console.log('Android $gtag event call::::::')
        //안드로이드 호출 후 실패시 
      } else {
        console.log('Android window.AnalyticsWebInterface not found ::::::')
        event(action, value)
        console.log('$gtag 기존 호출::::::');
      }
      //ios호출시
    } else if (isIOS()) {
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.experCounselHandler) {
        // Call iOS interface
        var message = {
          command: 'logEvent',
          name: action,
          parameters: JSON.stringify(value)
        };
        console.log('IOS $gtag parameters', message);
        window.webkit.messageHandlers.experCounselHandler.postMessage(message);
        console.log('IOS $gtag event call::::::')
      } else {
        console.log('IOS window.webkit.messageHandlers.experCounselHandler not found ::::::')
        event(action, value)
        console.log('$gtag 기존 호출::::::');
      }
    }
  } else {
    event(action, value)
    console.log('$gtag 기존 호출::::::');
  }
};

/**
 * 이모지 제거
 * @param id 
 * @param objName 
 * @param emojis 
 */
export const removeEmoji = (id: string, objName?: Record<string, any> | null, emojis?: RegExp): void => {
  let emojisStr = emojis ?? /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  if (objName) {
    objName[id] = objName[id].replace(emojisStr, '')
  } else {
    id = id.replace(emojisStr, '')
  }
};

/**
 * 앱 열기
 * @param action 
 * @param url 
 * @param depth 
 */
export const openApp = (action: string, url: string, depth?: any): void => {
  if (!action || !url) return;

  const config = useRuntimeConfig();
  let message = {};

  //풀브라우저일 경우 url에 도메인 붙이기
  if (action == 'moveFullBrowser') {
    url = `${config.public.VITE_HILDA_URL}${url}`;
  }

  //depth2값이 있으면 message에 추가
  if (depth) {
    message = {
      action: action,
      url: url,
      depth2: depth,
    };
  } else {
    message = {
      action: action,
      url: url,
    };
  }

  if (isAndroid()) {
    window.android.movePage(JSON.stringify(message));
  } else if (isIOS()) {
    window.webkit?.messageHandlers?.experCounselHandler?.postMessage(message);
  }
};

/**
 * 웹뷰 닫기 - 또박시즌2
 * 스토어에서 (null 및 historylength가 1일때 이전으로)
 */
export const closeWebview = () => {
  console.log('이게 실행됩니다:::::::::::');
  if (isAndroid() || isIOS()) {
    console.log('이게 실행됩니다222222222:::::::::::');
    navigateTo('/', { replace: true })
  }
};

export const openBrowser = (url: string) => {
  if (isMobileApp() && ttobakAppVersionCheck() === 'vsl4') {
    if (isAndroid()) {
      window.android.openBrowser(url);
    } else if (isIOS()) {
      var message = {
        action: "openBrowser",
        url: url,
      };
      window.webkit?.messageHandlers?.experCounselHandler?.postMessage(message);
    }
  } else {
    window.open(url)
  }
};

// query param값 그대로 가져오기
export const getRawQueryParam = (name: string): string | null => {
  const route = useRoute();
  
  if (!route.query[name]) return '';
  
  return encodeURIComponent(`${route.query[name]}`);
};


/**
 * 모바일페이지만 운영하는경우
 * @returns 
 */
export const isOnlyMobilePage = (): boolean => {
  const route = useRoute()
  return route.path.startsWith('/gift') || route.path.startsWith('/giftComplete')
}
